var submittalListToolbar = null,
	submittalListGrid = null,
	submittalTemplates = {
		submittals: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'Submittals', {
			isOldModule: true
		}),
		submittalHeader: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'SubmittalHeader', {
			isOldModule: true
		})
	}, showInfoDialogSubmittal, pjqSubmittalLoadId = null;

function SubmittalSubWallCheck() {
	return PJQ.app.session.project.get('masterUserId') !== PJQ.app.session.get('masterUserId');
}

function SubmittalListInit(el) {
	showInfoDialogSubmittal = (typeof showInfoDialogPWall === 'function') ? window.showInfoDialogPWall : window.showInfoDialog;
	PJQ.templating.TemplateRenderer.fetchTemplates(submittalTemplates, function () {
		RenderSubmittalList(el);
	});
}

function RenderSubmittalList(el) {
	el.html(submittalTemplates.submittals.jsRenderTemplate.render());

	submittalListToolbar = new dhtmlXToolbarObject("submittal-list-toolbar");
	submittalListToolbar.setSkin("dhx_web");
	submittalListToolbar.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");

	if (!SubmittalSubWallCheck()) {
		submittalListToolbar.addButton('add', 0, 'Add', "page.gif", "");
		submittalListToolbar.addButton('add_batch', 1, 'Add Batch', "page_range.gif", "");
	}

	submittalListToolbar.addButton('edit', 2, 'Edit', "Edit.jpg", "EditD.jpg");
	submittalListToolbar.disableItem('edit');

	if (!SubmittalSubWallCheck()) {
		submittalListToolbar.addButton('delete', 3, 'Delete', "Delete.png", "DeleteD.png");
		submittalListToolbar.disableItem('delete');

		submittalListToolbar.addSpacer("delete");

		submittalListToolbar.addButton('export_all', 4, 'Export All', "pdf.gif", "pdfD.gif");
	}

	submittalListToolbar.attachEvent("onClick", function (id) {
		switch (id) {
			case 'add':
				CreateSubmittalForm('add');
				break;
			case 'add_batch':
				CreateAddBatchForm();
				break;
			case 'edit':
				CreateSubmittalForm('edit', submittalListGrid.getSelectedRowId());
				break;
			case 'delete':
				showInfoDialogSubmittal('Delete Confirmation', 'Are you sure you want to delete this Submittal?', 'ui-icon-alert', 'delete-submittal');
				break;
			case 'export_all':
				SubmittalExportAll();
				break;
		}

	});

	submittalListGrid = new dhtmlXGridObject('submittal-list-grid');
	submittalListGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
	submittalListGrid.setSkin(pjqGridTheme);
	submittalListGrid.enableAutoHeight(true);
	//fieldReportsGrid.enableContextMenu(projectStatusGridMenu);
	submittalListGrid.init();
	submittalListGrid.attachEvent("onRowSelect", function (id, ind) {
		submittalListToolbar.enableItem('edit');

		if (SubmittalSubWallCheck())
			return;

		if (parseInt(id) > 0 && parseInt(submittalListGrid.getUserData(id, 'SubmittalStatus')) < 4)
			submittalListToolbar.enableItem('delete');
		else
			submittalListToolbar.disableItem('delete');

	});
	submittalListGrid.attachEvent("onRowDblClicked", function (rId, cInd) {
		CreateSubmittalForm('edit', rId);
	});

	submittalListGrid.loadXML(PJQ.helpers.urlHelpers.buildAPIURL(PJQ.helpers.urlHelpers.generateEndpoint([
		{
			endpoint: 'submittal'
		},
		{
			endpoint: 'getsubmittallist'
		}
	]), false, true), function () {
		if (PJQ.helpers.urlHelpers.getQueryParam('subid')) {
			setTimeout(function () {
				submittalformLastMode = 'edit';
				var subid = parseInt(PJQ.helpers.urlHelpers.getQueryParam('subid'));

				if (subid > 0)
					CreateSubmittalForm('edit', subid);
			}, 200);
		}
		else if(window.pjqSubmittalLoadId > 0){
			CreateSubmittalForm('edit', window.pjqSubmittalLoadId);
			window.pjqSubmittalLoadId = null;
		}
	});

	jQuery('#submittal-list-container').show();
}

function ReloadSubmittalList() {
	submittalListToolbar.disableItem('edit');
	if (!SubmittalSubWallCheck()) {
		submittalListToolbar.disableItem('delete');
	}

	submittalListGrid.clearAll();
	submittalListGrid.load(PJQ.helpers.urlHelpers.buildAPIURL(PJQ.helpers.urlHelpers.generateEndpoint([
		{
			endpoint: 'submittal'
		},
		{
			endpoint: 'getsubmittallist'
		}
	]), false, true), "xml");
}

function DeleteSubmittal() {
	PanteraScript.PanteraScriptService.DeleteSubmittal(pjqSessionId, parseInt(submittalListGrid.getSelectedRowId()), DeleteSubmittalC, onScriptError);
}

function DeleteSubmittalC() {
	ReloadSubmittalList();
}

function date_pantera(a, b, order) {
	var optionA = null;
	var optionB = null;
	var baseYear = 1900;

	if (a == 'ASAP') {
		optionA = new Date(new Date().setFullYear(2999));
	}
	else {
		try {
			optionA = new Date(a);
		} catch (err) {
			optionA = new Date(new Date().setFullYear(1901));
		}
	}

	if (b == 'ASAP') {
		optionB = new Date(new Date().setFullYear(2999));
	}
	else {
		try {
			optionB = new Date(b);
		} catch (err) {
			optionB = new Date(new Date().setFullYear(1901));
		}
	}

	if (!optionA.getDate()) {
		optionA = new Date(new Date().setFullYear(1901));
	}

	if (!optionB.getDate()) {
		optionB = new Date(new Date().setFullYear(1901));
	}


	if (optionA == optionB)
		return 0;

	if (order == "asc")
		return optionA > optionB ? 1 : -1;
	else
		return optionA < optionB ? 1 : -1;
}

function str_ci(a, b, order) { // the name of the function must be > than 5 chars
	if (order == "asc")
		return (a.toLowerCase() > b.toLowerCase() ? 1 : -1);
	else
		return (a.toLowerCase() > b.toLowerCase() ? -1 : 1);
}
